import { FetchRemoteConfig } from 'src/constants/actionTypes'
import type { RemoteConfigValues } from 'src/interfaces/remoteConfig'
import { Action } from 'src/utils/reduxUtils'
import type { RemoteConfigState } from './types'

const initialState: RemoteConfigState = {
  values: {},
  isLoaded: false,
}

export const remoteConfigReducer = (
  state: RemoteConfigState = initialState,
  action: Action<unknown>,
): RemoteConfigState => {
  switch (action.type) {
    case FetchRemoteConfig.type.SUCCESS:
      return { values: (action.payload as RemoteConfigValues | undefined) ?? {}, isLoaded: true }
    // A failed load leaves every screen on its built-in values.
    case FetchRemoteConfig.type.FAILED:
      return { values: {}, isLoaded: true }
    default:
      return state
  }
}
